import styles from './styles';

export default {
  commonStyles: styles
}
